import React from 'react'
import TableContainer from '@mui/material/TableContainer'

export default function EmbeddedTableContainer({ children, sx, ...props }) {
    return (
        <TableContainer
            sx={{
                overflowX: 'auto',
                ...sx,
            }}
            {...props}
        >
            {children}
        </TableContainer>
    )
}
